<template>
  <component
    :is="element"
    class="text-component"
    :class="[sizeClass, variant, weightClass]"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'HltText',
  props: {
    inline: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'md',
    },
    variant: {
      type: String,
      default: 'content-primary',
    },
    weight: {
      type: String,
      default: 'normal',
    },
  },
  computed: {
    element() {
      return this.inline ? 'span' : 'p';
    },
    sizeClass() {
      return `size-${this.size}`;
    },
    weightClass() {
      return `weight-${this.weight}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.text-component {
  font-size: rem-calc(16);
  line-height: 1.5rem;
  margin: 0;
  padding: 0;

  &.size-xs {
    font-size: rem-calc(12);
    line-height: rem-calc(16);
  }

  &.size-sm {
    font-size: rem-calc(14);
    line-height: rem-calc(20);
  }

  &.size-md {
    font-size: rem-calc(16);
    line-height: rem-calc(24);
  }

  &.content-primary {
    color: #000000;
  }

  &.content-secondary {
    color: #7B7B7B;
  }

  &.weight-semi {
    font-weight: $semi-bold;
  }

  &.weight-bold {
    font-weight: $bold;
  }
}
</style>
